import * as React from "react";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useLocation, Link } from "react-router-dom";
import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import useAxios from "../../../../api/useAxios";
import { API_URL } from "../../../../api";

export default function BankInfoDialog() {
  const instance = useAxios();
  const [bpData, setBpData] = useState([]);
  const token = localStorage.getItem("token");
  const api = axios.create({
    baseURL: API_URL(),
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [treatList, setTreatList] = useState([]);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [bodyParts, setBodyParts] = useState("");
  const [description, setDescription] = useState("");
  const [upCode, setUpCode] = useState("");
  const [upName, setUpName] = useState("");
  const [upBody, setUpBody] = useState("");
  const [upDesc, setUpDesc] = useState("");
  console.log(upBody, "up body");
  const TreateId = useLocation().pathname.split("/")[2];

  const TreatmentUpdate = () => {
    const data = {
      id: TreateId,
      name: upName,
      code: upCode,
      bodyParts: upBody,
      description: upDesc,
    };

    // console.log(data)
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api.put("treatment-list", data, config).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Updated Treatment Data!",
        icon: "success",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });
      // window.location.reload()

      // setMedicineLists([...medicineLists, response.data.list[0]])
      // setMedicineLists(
      //   medicineLists.map(category => {
      //     if (category._id === response.data.list[0]._id) {
      //       return response.data.list[0]
      //     } else {
      //       return category
      //     }
      //   })
      // )

      console.log(response.data.list);
    });
  };

  useEffect(() => {
    const getTreat = async () => {
      try {
        const res = await api.get(
          //"http://backendcherryk.kwintechnologykw11.com:4000/api/procedure-items/" +
          "treatment-list/" + TreateId,
        );

        console.log(res.data.data[0]);
        setUpName(res.data.data[0].name);
        setUpCode(res.data.data[0].code);
        setUpBody(res.data.data[0].bodyParts._id);
        setUpDesc(res.data.data[0].description);
      } catch (err) {}
    };

    const getBodyParts = async () => {
      try {
        const response = await instance.get("/ho/body-parts");
        setBpData(response.data.data);
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "Something Went Wrong",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      }
    };

    getTreat();
    getBodyParts();
  }, []);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/treatC">Back</Link>
                    </li>
                    <li className="breadcrumb-item active">Treatment Update</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div class="modal-body">
                <div class="form-group">
                  <label for="name">Code</label>
                  <input
                    type="text"
                    class="form-control border border-info"
                    name="code"
                    defaultValue={upCode}
                    onChange={(e) => setUpCode(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label for="name">Name</label>
                  <input
                    type="text"
                    class="form-control border border-info"
                    name="name"
                    defaultValue={upName}
                    onChange={(e) => setUpName(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label for="name">Choose Body Parts</label>
                  <select
                    name="currency"
                    id=""
                    className="form-control mt-1"
                    onchange="convert(this.value)"
                    value={upBody}
                    onChange={(e) => setUpBody(e.target.value)}
                  >
                    {bpData.map((bp, i) => (
                      <option value={bp._id}>{bp.name}</option>
                    ))}
                  </select>
                </div>
                <div class="form-group">
                  <label for="name">Description</label>
                  <textarea
                    className="form-control"
                    id="description"
                    defaultValue={upDesc}
                    onChange={(e) => setUpDesc(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <Button class="btn btn-secondary" data-dismiss="modal">
                  Close
                </Button>
                <button onClick={TreatmentUpdate} class="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
}
// phyo
//maymyat
